import React from 'react';
import { motion } from 'framer-motion';

const MarqueeSection = () => {
  const items = [
    'Medical Coding Excellence',
    'Claims Management',
    'Revenue Optimization',
    'Denial Prevention',
    'HIPAA Compliant',
    'Real-time Analytics',
    'Dedicated Support',
    'EHR Integration',
  ];

  return (
    <section className="py-12 bg-[#1e3a8a] overflow-hidden">
      <div className="relative flex">
        <motion.div
          animate={{
            x: [0, -1920],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: 'loop',
              duration: 30,
              ease: 'linear',
            },
          }}
          className="flex gap-16 whitespace-nowrap"
        >
          {[...items, ...items, ...items, ...items].map((item, index) => (
            <div
              key={index}
              className="text-2xl lg:text-3xl font-bold text-white/90 flex items-center gap-4"
            >
              <span>{item}</span>
              <span className="text-[#14b8a6]">•</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default MarqueeSection;
